<template>
  <div>
    <v-navigation-drawer v-model="drawer" app>
      <v-card class="mx-auto" tile>
        <v-img class="image-auto-size" :src="require('../assets/logo.png')"></v-img>
      </v-card>
      <v-divider></v-divider>
      <v-list dense shaped>
        <template mplate v-for="(item, index) in listOfMenu">
          <template v-if="item.isSettings">
            <v-divider :key="`${index}_divider`"></v-divider>
            <v-subheader class="subtitle-2" :key="`${index}_settings`">{{ $t('message.layout.settings') }}</v-subheader>
          </template>
          <v-list-item :key="`${index}_list`" v-if="!item.hasChildren" :to="item.to">
            <v-list-item-action class="menu-icon">
              <v-icon>{{ item.icon }}</v-icon>
              <span class="notificaion--badge" v-if="item.hasNotification"> </span>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group v-else :key="`${index}_children`" class="list--group" append-icon="mdi-chevron-down">
            <template v-slot:activator>
              <v-icon slot="prependIcon" class="menu-icon">
                {{ item.icon }}
              </v-icon>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </template>
            <v-list-item v-for="subItem in item.children" class="ml-3" :key="subItem.title" :to="subItem.to">
              <v-list-item-action class="menu-icon">
                <v-icon>{{ subItem.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t(subItem.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app absolute :color="getEnvironmentColor" dark :style="{ 'left': $vuetify.breakpoint.lgAndUp && drawer ? '269px' : '0px', 'border-radius': '5px'}">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon>menu</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-menu transition="slide-x-transition" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>language</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, i) in langItem"
                :key="i" @click="changeLang(item.value)" id="select_lang"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-chip class="ma-2" v-on="on" label color="primary" text-color="white">
            <v-avatar left>
              <v-icon>account_circle</v-icon>
            </v-avatar>
            <v-list-item-content class="username-css mx-1">
              <v-list-item-title v-text="userDetails.name"></v-list-item-title>
              <v-list-item-subtitle class="useremail-css" v-text="`(${userDetails.username})`"></v-list-item-subtitle>
            </v-list-item-content>
          </v-chip>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index" @click="menuActions(item.click)">
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- SUPPORT LIST DISPLAY -->
    <v-dialog v-model="supportList.dialog" persistent max-width="800px" class="mt-0">
      <v-form ref="supportFields" onSubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('message.common.addNew') }} {{ supportList.module }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row>
                <v-text-field dense class="mx-1" v-if="supportList.module === PRODUCT_GROUPS" outlined ref="autoFocus" @keyup.enter="addNewListItem" v-model="supportList.number" :label="$t('message.product.number')" :rules="$_requiredValidation"></v-text-field>
                <v-text-field dense :class="supportList.module === PRODUCT_GROUPS ? 'mx-1' : ''" outlined ref="autoFocus" @keyup.enter="addNewListItem" v-model="supportList.text" :label="$t('message.customer.name')" :rules="$_requiredValidation"></v-text-field>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="deleteConfirm" @click="addNewListItem">{{ $t('message.common.save') }}</v-btn>
            <v-btn color="error" id="deleteClose" @click="closeListItemDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- Custom Dialog -->
    <v-dialog v-model="customDialogObj.show" :width="customDialogObj.width || 600" :persistent="customDialogObj.persistent">
      <v-card>
        <v-card-title class="py-3 px-4 primary white--text">
          <span class="subtitle-1 font-weight-bold"> {{ customDialogObj.title }} </span>
          <v-spacer></v-spacer>
          <v-icon dark v-if="customDialogObj.titleIcon"> {{ customDialogObj.titleIcon }} </v-icon>
        </v-card-title>
        <v-card-text class="py-3 px-4 text-left">
          <span class="body-2 font-weight-medium"> {{ customDialogObj.body || '' }} </span>
        </v-card-text>
        <v-divider v-if="customDialogObj.actions && customDialogObj.actions.length"></v-divider>
        <v-card-actions v-if="customDialogObj.actions && customDialogObj.actions.length">
          <v-spacer></v-spacer>
          <template v-for="(btn, index) in customDialogObj.actions">
            <v-btn :key="index" v-if="btn.show" :color="btn.color" :disabled="btn.disabled" class="text-capitalize"
            @click="btn.click && btn.click({ dialog: customDialogObj })" :loading="btn.loading">
              {{ btn.label }}
            </v-btn>
          </template>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DELETE WARNING -->
    <v-dialog v-model="showDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.deleteConfirm') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.common.areYouSure') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="deleteConfirm" :loading="loading" @click="isLocalDelete ? dialogOk() : confirmDelete()">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="primary" id="deleteClose" @click="showDialog=false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Changes lost dialog -->
    <v-dialog v-model="getchangeLostDialog" persistent width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
        <v-card-text class="pa-5">
          <h4>{{ $t('message.common.changes_saved') }}</h4>
          <h3 class="mt-2">{{ $t('message.common.are_you_navigate') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="confirmToChanges">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="success" @click="$store.commit('changeLostDialog', false)">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Save update dialog-->
     <v-dialog v-model="getchangeSaveUpdateDialog" persistent width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
        <v-card-text class="pa-5">
          <h4>{{ $t('message.common.warning_saved') }}</h4>
          <h3 class="mt-2">{{ $t('message.common.save_continued') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="confirmToSave">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="error" @click="$store.commit('changeSaveUpdateDialog', false)">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import menuList from './menus'
export default {
  data () {
    return {
      drawer: null,
      items: [{ title: 'message.user.profile', click: 'user-profile' },
        { title: 'message.layout.logout', click: 'logout' }],
      listName: '',
      listDefault: false,
      loading: false,
      customDialogObj: {
        // eslint-disable-next-line
        close: () => this.customDialogObj.show = false
      },
      menus: menuList
    }
  },
  computed: {
    getEnvironmentColor () {
      return process.env.VUE_APP_LAYOUT_COLOR
    },
    ...mapState(['showDialog', 'userDetails', 'deletePayload', 'supportList', 'isChangesMade', 'isLocalDelete']),
    ...mapGetters(['getchangeLostDialog', 'getchangeSaveUpdateDialog', 'getuserDetails']),
    isAdmin () {
      return this.getuserDetails ? this.getuserDetails.role === 1 || this.getuserDetails.role === 0 : false
    },
    listOfMenu () {
      let list = this.$formatter.cloneVariable(this.menus)
      if (this.getuserDetails.role === 3) return list.filter(x => !x.hideForTechRole)
      else if (this.getuserDetails.role === 2) return list.filter(x => !x.hideForOffice)
      else return list
    },
    cartItems () {
      return this.$store.state.cartItems
    },
    showDialog: {
      get () {
        return this.$store.state.showDialog
      },
      set (val) {
        if (!val) this.$store.commit('hideDialog')
      }
    },
    username () {
      if (this.$store.state.userDetails) {
        return this.$store.state.userDetails.email
      } else return 'Admin'
    },
    getURL () {
      let url = process.env.VUE_APP_URL
      return url.split('/api')[0]
    },
    langItem () {
      let language
      if (this.$i18n.locale === 'en') {
        language = [{ title: this.$t('message.common.norwegian'), value: 'no' }]
      } else if (this.$i18n.locale === 'no') {
        language = [{ title: this.$t('message.common.english'), value: 'en' }]
      }
      return language
    }
  },
  watch: {
    'supportList.dialog' (val) {
      if (val) {
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (this.$refs.autoFocus) {
              this.$refs.autoFocus.focus()
            }
          }, 300)
        })
      }
    }
  },
  mounted () {
    if (this.$store.state.userDetails.id === -100) {
      this.items.splice(0, 1)
    }
    let self = this
    window.addEventListener('beforeunload', function (e) {
      if (self.isChangesMade) {
        // eslint-disable-next-line no-useless-escape
        var confirmationMessage = '\o/'
        console.log('');
        (e || window.event).returnValue = confirmationMessage
        console.log(confirmationMessage)
        if (confirmationMessage) {
        }
        return confirmationMessage
      } else {
        return false
      }
    })
    this.$root.$on('customDialog', (data) => {
      this.customDialogObj = Object.assign(data, { ...this.customDialogObj, show: true })
    })

    this.$eventBus.$on('TotalTicketCount', (totalCount) => {
      var ticketMenuIndex = this.menus.findIndex(x => x.to === '/tickets')
      if (ticketMenuIndex !== -1) {
        this.$set(this.menus, ticketMenuIndex, { ...this.menus[ticketMenuIndex], hasNotification: (+totalCount > 0) })
      }
    })

    this.$eventBus.$on('checkIfUnreadMailsExists', (totalCount) => {
      this.checkTicketsNotifications()
    })
  },
  methods: {
    checkTicketsNotifications () {
      this.$_executeApi('get', '/mails/check_if_unread_mail_exists')
    },
    confirmDelete () {
      this.loading = true
      let model = this.deletePayload
      if (model.isSingle) {
        this.$store.dispatch('deleteSingleRecordHandler', model)
          .then(() => {
            this.$eventBus.$emit('deleteSuccess', model.module)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$store.dispatch('deleteHandler', model)
          .then(() => {
            this.$eventBus.$emit('deleteSuccess', model.module)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    menuActions (action) {
      switch (action) {
        case 'logout':
          this.$store.commit('isChangesMade', false)
          this.$store.dispatch('logout')
          this.$router.push('/login')
          break
        case 'clear-od':
          this.clearOneDrive()
          break
        case 'user-profile':
          this.$router.push('/user_profile')
          break
        default:
          break
      }
    },
    clearOneDrive () {
      this.$_executeApi('post', 'onedrivesettings/clear_my_token', null)
        .then((response) => {
          if (response.data) {
            this.$router.push('/hse')
          }
        })
    },
    addNewListItem () {
      var allModules = {
        [this.USERROLES]: 'getUserRoles',
        [this.GROUPS]: 'getGroups',
        [this.PRODUCT_GROUPS]: 'getProductGroups',
        [this.TICKET_STATUS]: 'getStatus',
        [this.PRIORITY]: 'getPriority',
        [this.TYPE]: 'getTypes',
        [this.DEVIATION_LOCATIONS]: 'getDeviationLocation',
        [this.DEVIATION_CATEGORIES]: 'getDeviationCategory',
        [this.DEVIATION_STATUS]: 'getDeviationStatus',
        [this.CUSTOMER_PRIORITY]: 'getCustomerPriority',
        [this.CUSTOMER_INDUSTRY]: 'getCustomerIndustry',
        [this.CUSTOMER_SHIPMENT]: 'getCustomerShipment',
        [this.WAREHOUSE]: 'getWarehouse',
        [this.PAYMENTTERMS]: 'getPaymentTerms',
        [this.DELIVERYTERMS]: 'getDeliveryTerms',
        [this.PRODUCTUNITS]: 'getUnits'
      }

      if (this.$refs.supportFields.validate()) {
        let model = { name: this.supportList.text, isactive: true }
        if (this.supportList.module === this.PAYMENTTERMS) {
          model.days = this.supportList.text
          delete model.name
        }
        if (this.supportList.module === this.PRODUCT_GROUPS) {
          model.number = this.supportList.number
        }
        let url = this.supportList.module
        this.$_executeApi('post', `${url}`, model)
          .then((response) => {
            let supportListModel = this.$formatter.cloneVariable(this.supportList)
            if (allModules[this.supportList.module]) {
              let dispatchPromise = null
              if (this.supportList.module === this.PAYMENTTERMS) dispatchPromise = this.$store.dispatch(allModules[this.supportList.module], this.$t('message.common.days'))
              else dispatchPromise = this.$store.dispatch(allModules[this.supportList.module])
              dispatchPromise.then(() => {
                if (response.data) {
                  supportListModel.recordId = supportListModel.module === this.PAYMENTTERMS ? response.data.days : response.data.id
                  this.$eventBus.$emit('setItemInField', supportListModel)
                }
              })
            }
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.addedSucess') })
            this.$store.commit('supportingList', { dialog: false })
            /* switch (this.supportList.module) {
              case this.USERROLES:
                this.$store.dispatch('getUserRoles')
                break
              case this.GROUPS:
                this.$store.dispatch('getGroups')
                break
              case this.PRODUCT_GROUPS:
                this.$store.dispatch('getProductGroups')
                break
              case this.TICKET_STATUS:
                this.$store.dispatch('getStatus')
                break
              case this.PRIORITY:
                this.$store.dispatch('getPriority')
                break
              case this.TYPE:
                this.$store.dispatch('getTypes')
                break
              case this.DEVIATION_LOCATIONS:
                this.$store.dispatch('getDeviationLocation')
                break
              case this.DEVIATION_CATEGORIES:
                this.$store.dispatch('getDeviationCategory')
                break
              case this.DEVIATION_STATUS:
                this.$store.dispatch('getDeviationStatus')
                break
              case this.CUSTOMER_PRIORITY:
                this.$store.dispatch('getCustomerPriority')
                break
              case this.CUSTOMER_INDUSTRY:
                this.$store.dispatch('getCustomerIndustry')
                break
              case this.CUSTOMER_SHIPMENT:
                this.$store.dispatch('getCustomerShipment')
                break
              case this.WAREHOUSE:
                this.$store.dispatch('getWarehouse')
                break
              default:
                break
            } */
          }).finally(() => {
            this.$refs.supportFields.reset()
          })
      }
    },
    closeListItemDialog () {
      this.$refs.supportFields.reset()
      this.$store.commit('supportingList', { dialog: false })
    },
    changeLang (language) {
      this.$i18n.locale = language
      this.$cookie.set('kilab_locale', language)
    },
    confirmToSave () {
      this.$eventBus.$emit('saveUpdateHandler', this.SAVE)
      this.changesLostHandler()
    },
    confirmToChanges () {
      const route = this.$router.history.pending
      if (route) {
        this.changesLostHandler()
        this.$router.push(route.fullPath)
      } else {
        this.changesLostHandler()
      }
    },
    changesLostHandler () {
      this.$store.commit('isChangesMade', false)
      this.$store.commit('changeLostDialog', false)
      this.$store.commit('changeSaveUpdateDialog', false)
    },
    dialogOk () {
      this.$store.commit('dialogOk')
    }
  },
  beforeDestroy () {
    this.$root.$off('customDialog')
    this.$eventBus.$off('TotalTickerCount')
  }
}
</script>
<style>
  .image-auto-size .v-image__image--cover {
    background-size: auto !important;
  }
  .max-width-30-per {
    max-width: 30%;
  }
  .menu-icon {
    border-radius: 6px;
    padding: 3.5px;
    margin-right: 20px !important;
    box-shadow: 1px 1px 1px 0px #6d5959;
  }
  .username-css {
    max-width: fit-content;
  }
  .useremail-css {
    font-size: 0.66rem !important;
  }
  .list--group .v-list-item {
    min-height: 50px !important;
  }
  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: 0px 3px 1px -2px rgb(255 255 255 / 20%), 0px 2px 2px 0px rgb(210 210 210 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%) !important;
  }
  .notificaion--badge {
    width: 8px;
    height: 8px;
    background-color: #fd5f56;
    color: white;
    padding: 0.3em 0.8em;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 188px;
    font-size: 0.3em;
  }
</style>
